<div class="mb-4 flex justify-end">
  @if (
    proposal.statusPropostaId != 1 &&
    proposal.statusPropostaId != 5 &&
    proposal.statusPropostaId != 6 &&
    proposal.statusPropostaId != 9
  ) {
    <button mat-raised-button class="btn-add" (click)="createItineraries()">
      Inserir
      <mat-icon>add</mat-icon>
    </button>
  }
</div>
<div>
  <!--  <form-client-search-->
  <!--    [search]="inputSearchContact"-->
  <!--    [listSearch]="listSearch"-->
  <!--    (responseSearch)="search($event)"-->
  <!--  />-->
  @if (!loading) {
    <div class="tab-overflow">
      <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
        @for (column of columns; track column.keyColumn) {
          <ng-container matColumnDef="{{ column.keyColumn }}">
            <th mat-header-cell *matHeaderCellDef>
              {{ column.description }}
            </th>
            <td mat-cell *matCellDef="let element">
              @if (column.keyColumn == 'action') {
                <div class="flex justify-center items-center gap-3">
                  @if (
                    proposal.statusPropostaId != 1 &&
                    proposal.statusPropostaId != 5 &&
                    proposal.statusPropostaId != 6
                  ) {
                    @if (column.key.edit) {
                      <mat-icon
                        class="btn-icon-outline"
                        fontIcon="edit"
                        (click)="editItem(element)"
                      />
                    }
                    @if (column.key.delete) {
                      <mat-icon
                        class="btn-icon-outline"
                        fontIcon="delete"
                        (click)="deleteItem(element)"
                      />
                    }
                  }
                </div>
              } @else if (column.keyColumn == 'areaTarrif') {
                {{ element[column.key] == 'S' ? 'Dentro' : 'Fora' }}
              } @else {
                {{ element[column.key] }}
              }
            </td>
          </ng-container>
        }
        <tr
          mat-header-row
          class="style-header"
          *matHeaderRowDef="displayedColumns"
        ></tr>
        <tr
          mat-row
          class="style-row"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
  } @else {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
  @if (!loading) {
    <mat-paginator
      #paginator
      [length]="numberRows"
      [pageSize]="rows"
      [pageIndex]="page - 1"
      [pageSizeOptions]="[5, 10, 25]"
      (page)="pageChanged($event)"
    >
    </mat-paginator>
    <!--    <mat-paginator-->
    <!--      [hidden]="loading || itemsList.length == 0"-->
    <!--      #paginator-->
    <!--      [pageSize]="rows"-->
    <!--      [pageIndex]="page"-->
    <!--      [pageSizeOptions]="[5, 10, 25, 50]"-->
    <!--      (page)="pageChanged($event)"-->
    <!--    >-->
    <!--    </mat-paginator>-->
  }
</div>
